import React, { useState, useEffect, lazy, Suspense, useRef, startTransition } from "react";
import { useTranslation } from "react-i18next";
import jwtDecode from "jwt-decode";
import addLineBreaks, { clearStorageExceptKey, delayForDemo } from "../../../utils";
import TrustDevice from "../../Login/TrustDevice";
import VerifyOtp from "../../Login/VerifyOtp";
import { v4 as uuidv4 } from "uuid";
import { useOidc, useOidcAccessToken } from "@axa-fr/react-oidc";
import {
  retrieveData,
  storeData,
  DEVICE_VERIFICATION,
  fetchConfigarationData,
  showPrompt,
  appTheme,
  isSmiOneAccountTrue,
  hasKudzuCardTrue,
  CHECKING_CARD_CODE,
} from "../../../helpers/utils/Utils";
import {
  GetApiHeadersWithBearer,
  GetApiHeadersWithOutBearer,
  GetRequest,
  PostRequest,
} from "../../../network/NetworkUtils";
import {
  POST_LOGIN,
  POST_REGISTER_FCM_TOKEN,
  STATUS_SUCCESS_CODE,
  GENERATE_OTP,
  TWO_AUTH_VERIFY_OTP,
  PROGRAM_CONTENT,
  SAVING_CARD_CODE,
  SIGN_UP_FEATURE,
  CONTACT_US_URL,
  VERIFY_ACCESS_CODE,
  GET_CIP_STATUS,
  ENROLL_STATUS_APP,
  ENROLL_STATUS_REV,
  ENROLL_STATUS_DEC,
  ENROLL_STATUS_PEN,
  END_SESSION,
  IDOLOGY_CAMEL_CASE,
  SIGN_UP_KUDZUPLUS_CHECK,
  SMI_ONE_INITIATE_SESSION,
  SVA_CONFIGURATION_UPDATE
} from "../../../network//URLConstants";
import { connect, useDispatch, useSelector } from "react-redux";
import Loader from "../../CustomComponents/Loader";
import { LOGIN_SESSION_KEY, SHOW_SECURED_CREDIT_POPOVER } from "../../../Redux/reducers";
import { useLocation, useNavigate } from "react-router-dom";
import Banner from "../../../assets/images/banner.png";
import report from "../../../assets/images/illo-report.png";
import Klogo from "../../../assets/images/K.png";
import NextArrow from "../../../assets/images/NextArrow.png";
import Check from "../../../assets/images/earlyAccessCheck.png";
import Trusted from "../../../assets/images/illo-trusted-devices.png";
import { replace, useParams } from "react-router";
import { displaySignupErrorMessage } from "../../../utils";
import debounce from "lodash.debounce";
import ExistingErrorModal from "../../OnBoard/Signup/ExistingErrorModal";
import AccessCode from "../../OnBoard/Signup/AccessCode";
import { useKeyDown } from "../../../hooks/useKeyDown";
import logFirebaseEvents from "../../LogFirebaseEvents";
import CustomAlertModel from "../../CustomComponents/CustomAlertModel";
import { store, persistor } from '../../../Redux/store';
import CustomCarousel from "../../../kudzu_plus/helpers/customCarousel";
import LandingCarousel from "../LandingCarousel";
import Cookies from 'js-cookie';
import CustomModalPlus from "../../../kudzu_plus/helpers/customModalPlus";
import MemnershipEnrollmentScreens from "../../../kudzu_plus/components/membershipEnrollmentScreens";
import FooterContent from "../../CustomComponents/Footer";
import kudzu_logo_with_card from '../../../assets/smi-kudzu-images/kudzuLogo_with_card.png'
import smiKudzu from '../../../assets/smi-kudzu-images/kudzu-smi.png'
import MobileErrorModal from "../MobileErrorModal";
import { color } from "framer-motion";
import { useDocumentTitle } from '../../../hooks/useDocumentTitle';



const Header = lazy(() => delayForDemo(import("../Header")));

const Modal = lazy(() => import("../../CustomComponents/Modal"));
const MobileVerification = lazy(() =>
  import("../../OnBoard/Signup/MobileVerification")
);
const ValidatePhoneOTP = lazy(() =>
  import("../../OnBoard/Signup/MobileVerification/ValidateOTP")
);
const ValidateAuthCode = lazy(() =>
  import("../../OnBoard/Signup/MobileVerification/ValidateAuthCode")
);
const VerifyEmail = lazy(() => import("../../ResetPassword/VerifyEmail"));
const SecurityCheck = lazy(() => import("../../ResetPassword/SecurityCheck"));
const ResetYourPassword = lazy(() =>
  import("../../ResetPassword/ResetYourPassword")
);
const ResetSuccess = lazy(() => import("../../ResetPassword/ResetSuccess"));
// const TrustDevice = lazy(() => import('../../Login/TrustDevice'));
// const VerifyOtp = lazy(() => import('../../Login/VerifyOtp'));
// const Banner = lazy(() => import('../../../assets/images/banner.png'));
// const Trusted = lazy(() => import('../../../assets/images/illo-trusted-devices.png'));
const TwoFactTypeSelctionModal = lazy(() =>
  import("../../CustomComponents/TwoFactTypeSelctionModal")
);
const appConfigData = await fetchConfigarationData();

export const ACTIVITY_TYPE_E_SIGN = "ESign";
const PreLogin = ({LinkSmiOneCard}) => {
 
  const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue); 
      const appThemeData = appTheme(kudzuPlusTrue);
  const appConfigData = useSelector(state => state.appConfigData);
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  //styles for input
  const HeadingStyles =
    "font-serif-pro modal-title sm:text-[18px] lg:text-[32px] md:text-[28px] text-[25px] sm:leading-[24px] lg:leading-[38px] md:leading-[33px] leading-[31px] font-normal text-[var(--modal-text-highlight)]";
  const HeadingUpdatedStyles = 
    "font-serif-pro modal-title sm:text-[18px] lg:text-[32px] md:text-[28px] text-[25px] sm:leading-[24px] lg:leading-[38px] md:leading-[33px] leading-[31px] font-normal text-[var(--modal-text-heading-clr)]"
  const SubHeadingStyles =
    "w-[90%] md:w-full font-serif-pro modal-title sm:text-[18px] lg:text-[30px] md:text-[28px] text-[25px] sm:leading-[24px] lg:leading-[38px] md:leading-[33px] leading-[31px] font-normal text-[var(--modal-text-heading-clr)]";
  // const SubHeadingStyles = "lg:w-[400px] md:w-[400px] sm:w-[224px] font-serif-pro modal-title sm:text-[18px] lg:text-[32px] md:text-[28px] text-[25px] sm:leading-[24px] lg:leading-[38px] md:leading-[33px] leading-[31px] font-normal text-secondary-3";
  const FailSubHeaderMsgStyles =
    "md:w-[317px] sm:w-[257px] font-hanken-grotesk modal-title  md:text-[18px] sm:text-[14px] text-[16px] font-normal cursor-pointer";
  //modal styles
  const SubTittleStylesModal =
    "font-serif-pro modal-title sm:text-[18px]  lg:text-[32px] md:text-[28px] text-[25px] sm:leading-[24px] lg:leading-[38px] md:leading-[33px] leading-[31px] font-normal text-secondary-2";

  const HighlightMsgStyles =
    "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[37px] font-normal text-[var(--modal-text-highlight)] cursor-pointer pointer-events-none";

  const HeaderMsgStyles =
    "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[37px] font-normal cursor-pointer pointer-events-none text-[var(--modal-text-heading-clr)] ";

  const SubHeaderMsgStyles =
    "sm:w-auto w-[200px] font-hanken-grotesk text-[var(--modal-text-heading-clr)]  modal-title lg:text-[20px] md:text-[18px] sm:text-[14px] text-[16px] font-[500] cursor-pointer";

  const summaryParagraphStyles = "font-hanken-grotesk modal-title text-white lg:text-[12px] md:text-[10px] sm:text-[6px] text-[8px] font-[200] cursor-pointer pointer-events-none";
  const HeaderMsgStylesForPlus = "font-serif-pro modal-title text-white lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[31px] font-[400] cursor-pointer pointer-events-none";

  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  // const params = useParams();
  const { forgotEmail } = useParams();
  const currentpath = useLocation()


  const [isMobileVerificationModalOpen, setIsMobileVerificationModalOpen] = useState(false);
  // niharika start
  const [isWelcomeCarouselModalOpen, setIsWelcomeCarouselModalOpen] = useState(false);
  const [showPlusModal, setShowPlusModal] = useState(false);
  const [carousel, setCarousel] = useState('');
  const [isBorderNone, setisBorderNone] = useState(true);
  const [btn1BgColor, setBtn1BgColor] = useState("");
  const [summaryParagraph, setSummaryParagraph] = useState('');
  const [opacityValueLow, setOpacityValueLow] = useState(false);
  const [comparisonScreen, setComparisonScreen] = useState('');
  const [fullWidth, setFullWidth] = useState(false);
  const [footerButtonEnable, setFooterButtonEnable] = useState(false);
  const [gradientButton, setGradientButton] = useState(false);
  const [largeImage, setLargeImage] = useState(false);
  const [showCarouselScreenShow, setShowCarouselScreensShow] = useState(false);
  const makeOpenSmiOnborad = useSelector(x => x.makeOpenSmiOnborad)
 
  // niharika end
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const [loginOTP, setLoginOTP] = useState("");
  const [isVerifyEmailModalOpen, setIsVerifyEmailModalOpen] = useState(false);
  const [forgotEmailAddress, setForgotEmailAddress] = useState("");
  const [isOTPVerifyModalOpen, setIsOTPVerifyModalOpen] = useState(false);
  const [authUserCodeModelOpen, setAuthUserCodeModelOpen] = useState(false);
  const [existingErrorModalOpen, setExistingErrorModalOpen] = useState(false);
  const [isLoginTrustDeviceOpen, setLoginTrustDeviceOpen] = useState(false);
  const [actionType, setActionType] = useState(DEVICE_VERIFICATION);
  const [showPassCodeExpire, setShowPassCodeExpire] = useState(false);
  const [isTryAgain, setIsTryAgain] = useState(false);
  const [showValidationMsg, setShowValidationMessage] = useState(false);
  const [loginOtpErrorMessage, setLoginOtpErrorMessage] = useState("");
  const [loginTyagainCount, setLoginTryAgainCount] = useState(1);
  const [showAgreementsModel, setShowAgreementsModel] = useState(false);
  const [policyURL, setPolicyURL] = useState("");
  const [phScreenAgreeTerms, setphScreenAgreeTerms] = useState(false);
  const [SingupCheckBoxMessage, setSingupCheckBoxMessage] = useState("");
  const [greyBg, setGreyBg] = useState(false);
  const [show2faSelection, setshow2faSelection] = useState(false);
  const [selectedOtpType, setSelectedOtpType] = useState("");
  const [showPolicys, setShowPolicys] = useState("terms");
  const [isAccessCodeModalOpen, setIsAccessCodeModalOpen] = useState(false);
  const [handleSkipClicked, setHandleSkipClicked] = useState(false);
  const [isAccessCodeErrorModalOpen, setIsAccessCodeErrorModalOpen] =
    useState(false);
  const [isAccessCodeNoWorriesModalOpen, setIsAccessCodeNoWorriesModalOpen] =
    useState(false);
  const [validAccessCode, setValidAccessCode] = useState(false);
  const [callVerifyAccessCodeApi, setCallVerifyAccessCodeApi] = useState(false);
  const [steps, setSteps] = useState(1);

  const isLoginDeviceTrusted = useSelector(
    (state) => state.isLoginDeviceTrusted
  );
  const accessTokenToApi = useSelector((state) => state.accessToken);
  const userLanguage = useSelector((state) => state.userLanguage);
  const userProfile = useSelector((state) => state.userProfile);
  const cards = useSelector(state => JSON.parse(state.userCards));
  const userCards = useSelector((state) => state.userCards);
  const userActivities = useSelector((state) => state.userActivities);
  // const deviceId = useSelector(state => state.deviceId);
  const sessionKey = useSelector((state) => state.loggedSessionKey);
  const deepLinkPath = useSelector((state) => state.deepLinkPath);
  const isFromSmiOne = useSelector((state) => state.fromSmiOne);

  const idFromSmiOne = useSelector((state) => state.smiOneId);
  const [canContinue, setCanContinue] = useState(false);

  const selectedCardDetails = useSelector(state => state.selectedCardDetails);
  const isB2c = useSelector(state => state.preferredIdentity);
  const welcomeCarouselSkipValueVal = useSelector(state => state.welcomeCarouselSkipValue);
  


  const [agreementType, setAgreementType] = useState([
    { name: "Kudzu Privacy Policy", url: "PPrivacyPolicy", accType: 64 },
    { name: "SMS Services", url: "SMSTerms", accType: 0 },
    { name: "Bancorp Privacy Notice", url: "PrivacyPolicyV2", accType: 0 },
    { name: "Kudzu User Agreement", url: "TnC", accType: 64 },
  ]);

  const [showModel, setShowModel] = useState(false);
  const [highlightMsg, setHighlightMsg] = useState("");
  const [headerMsg, setheaderMsg] = useState("");
  const [subHeaderMsg, setSubHeaderMsg] = useState("");
  const [btn1Exists, setBtn1Exists] = useState(false);
  const [btn2Exists, setBtn2Exists] = useState(false);
  const [btn1Text, setBtn1Text] = useState("");
  const [btn2Text, setBtn2Text] = useState("");
  const [btn1TypeAcpt, setBtn1TypeAcpt] = useState(false);
  const [modelImage, setModelImage] = useState(null);
  const [isSignupPhoneValid, setIsSignupPhoneValid] = useState(false);
  const [enrollStatus, setEnrollStatus] = useState("");
  const [cipFlow, setCipFlow] = useState("");
  const [secureFormURL, isSecureFormURL] = useState("/");
  const [kudzuSmiOneModal, setKudzuSmiOneModal] = useState(false)
  const [responseErrorMsg, setResponseErrorMsg] = useState("");
  const [showSmiOneErrorModal, setShowSmiOneErrorModal] = useState(false);
  
  const loggedInResponses = useSelector(state => state.b2cEnabled);
  const B2C_enabled = loggedInResponses;

// new modal for smi welcome carousels
 const [isWelcomeCarouselModalOpenForSMI, setIsWelcomeCarouselModalOpenForSMI] = useState(false);
 const [stopTrailCarousels, setStopTrailCarousels] = useState(false);

    // Set document title based on current path
    const currentPath = window.location.pathname;
    const documentTitle =
        currentPath.toLowerCase() === "/forgotpassword"
            ? t('page_title_forgot_password')
            : currentPath.toLowerCase() === "/login"
                ? t('page_title_sign_in')
                : currentPath.toLowerCase() === "/signup"
                    ? t('page_title_create_account')
                    : currentPath.toLowerCase() === "/"
                        ? t('page_title_journeyToGrowth')
                        : currentPath.toLowerCase() === "/logout"
                            ? t('page_title_signed_out')
                            : t('page_title_journeyToGrowth');
    useDocumentTitle(documentTitle);

  useEffect(() => {

      dispatch({ type: 'PLUS_OR_BASIC', payload: { kudzuPlusOrBasic: true } }); 
    
    sessionStorage.setItem("tooltipState_Spending", 0);
    sessionStorage.setItem("tooltipState_Saving", 0);
    const currentPath = location.pathname;
    if (currentPath.toLowerCase() == "/forgotpassword") {
      logFirebaseEvents("Login", "Forgot_Password_Clicked", "Forgot_Password_Clicked", "");
      const currentUrl = window.location.href;
      const url = new URL(currentUrl);
      const emailParam = url.searchParams.get("email");
      setForgotEmailAddress(emailParam);
      setTimeout(() => {
        setIsVerifyEmailModalOpen(true);
      }, 1000);
    } else if (currentPath.toLowerCase() == "/signup") {
      logFirebaseEvents("Social_Login", "Signup_Clicked ", "Signup_Clicked ", "", "");
      const currentURL = new URL(window.location.href);
      const accessParam = currentURL.searchParams.get("id");

      dispatch({
        type: "UPDATE_SIGNUP_REFERRAL_CODE",
        payload: { signUpReferralCode: accessParam },
      });
      
      if(isFromSmiOne){
        debugger
        const kudzuPlusSetForCookies = `kudzuPlusTrueFromCookies`;
        Cookies.remove(kudzuPlusSetForCookies);
        document.body.classList.remove('dark-theme');
        document.body.classList.add('light-theme');
        hanldleWelcomeSmiOne()
      }else{
        if(location.state?.directSignup) {
          const kudzuPlusSetForCookies = `kudzuPlusTrueFromCookies`;
          Cookies.remove(kudzuPlusSetForCookies);
          setIsMobileVerificationModalOpen(true);
        } else if(currentPath.toLowerCase() ===  "/signup"){
          const kudzuPlusSetForCookies = `kudzuPlusTrueFromCookies`;
          Cookies.remove(kudzuPlusSetForCookies);
          setIsMobileVerificationModalOpen(true);
        }else{
          setIsWelcomeCarouselModalOpen(true);
        }
      }

    } else if (currentPath == "/" && accessToken == null) {
      const fromLandingCarousel = sessionStorage.getItem('fromLandingCarousel') === 'true';
      
      if (fromLandingCarousel) {
        sessionStorage.removeItem('fromLandingCarousel');
        sessionStorage.removeItem('returningToLandingCarousel');
        const data = { welcomeCarouselSkipValue: false };
        dispatch({ type: 'WELOCME_CAROUSEL_SKIP', payload: data });
        console.log("PreLogin: User came from landing carousel, returning to landing carousel");
        setIsWelcomeCarouselModalOpen(true);
      } else if(welcomeCarouselSkipValueVal === true && stopTrailCarousels == true) {
        kudzuplusAvailable(false); // Don't pass skip flag for post-signup
      } else {
        // New user landing on home page, show landing carousel
        console.log("PreLogin: Home page detected, showing carousel");
        if(isFromSmiOne){
          debugger
          const kudzuPlusSetForCookies = `kudzuPlusTrueFromCookies`;
          Cookies.remove(kudzuPlusSetForCookies);
          document.body.classList.remove('dark-theme');
          document.body.classList.add('light-theme');
          hanldleWelcomeSmiOne()
        } else {
          if(location.state?.directSignup) {
            setIsMobileVerificationModalOpen(true);
          } else {
            console.log("PreLogin: Setting welcome carousel modal open to true");
            setIsWelcomeCarouselModalOpen(true);
          }
        }
      }
    } else if (currentPath.toLowerCase() == "/logout") // && accessToken == null /
    {
      logout()
      store.dispatch({ type: 'LOGOUT' });
      const loginPayload = { isLoggedIn: false };
      dispatch({ type: 'LOG_IN', payload: loginPayload });
      login("/");
    }
  }, [location, accessTokenToApi]);

  useEffect(() => {
    const currentPath = location.pathname;
    if (
      accessToken !== null &&
      accessToken !== undefined &&
      accessTokenToApi != null &&
      accessTokenToApi != "" &&
      isAuthenticated &&
      currentPath.toLowerCase() !== "/forgotpassword" &&
      currentPath.toLowerCase() !== "/signup" &&
      currentPath.toLowerCase() !== "/logout"
    ) {
      // registerBrowser(accessTokenToApi);
      const userIdPayload = { userId: '' }
      dispatch({ type: 'USER_ID', payload: userIdPayload });
      checkCipStatus(accessTokenToApi);
    }
  }, [accessTokenToApi]);

  const { login, logout, isAuthenticated, renewTokens, oidcUser } = useOidc();
  const { accessToken } = useOidcAccessToken();
  const isSessionExpired =
    !oidcUser || !oidcUser.access_token || oidcUser.expired;

  const OpenMobileVerificationModal = () => {
    setIsAccessCodeModalOpen(false);
    setIsMobileVerificationModalOpen(true);
  };

  const closeInitialSignupscreen = () => {
    const returningToLandingCarousel = sessionStorage.getItem('returningToLandingCarousel') === 'true';
   
    setIsMobileVerificationModalOpen(false);
    
    if (returningToLandingCarousel) {
      sessionStorage.removeItem('returningToLandingCarousel');
      sessionStorage.removeItem('fromLandingCarousel'); 
      
      // Reset carousel skip state so user can interact with carousel again
      const data = { welcomeCarouselSkipValue: false };
      dispatch({ type: 'WELOCME_CAROUSEL_SKIP', payload: data });
     
      setIsAccessCodeModalOpen(false);
      setIsLoginModalOpen(false);
      setIsVerifyEmailModalOpen(false);
      setIsOTPVerifyModalOpen(false);
      setExistingErrorModalOpen(false);
      setIsAccessCodeErrorModalOpen(false);
      setIsAccessCodeNoWorriesModalOpen(false);
      setShowAgreementsModel(false);
      setAuthUserCodeModelOpen(false);
      
      console.log("PreLogin: Returning to landing carousel from signup");
      
      // Use setTimeout to ensure all modal states are cleared before opening carousel
      setTimeout(() => {
        setIsWelcomeCarouselModalOpen(true);
      }, 100);
    } else {
      // Default behavior - redirect to login
      login("/");
    }
  };

  const closeMobileVerificationModal = () => {
    setIsMobileVerificationModalOpen(false);
  };

  useEffect(() => {
    const handlePopState = () => {
      if (isMobileVerificationModalOpen) {
        closeMobileVerificationModal();
      }
    };
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, [isMobileVerificationModalOpen]);


  const goToOnBoard =() =>{
        const isMobileVerifiedPayload = { isMobileVerifed: true }
        dispatch({ type: 'MOBILE_VERIFIED', payload: isMobileVerifiedPayload });
        navigate('/Onboard');
  }

  useEffect(() => {
    const fetchData = async () => {
      if (accessToken && accessToken !== null && accessToken !== "") {
        const accessTokenPayload = { accessToken: accessToken };
        dispatch({ type: "ACCESS_TOKEN", payload: accessTokenPayload });
      }
    };
    fetchData();
  }, [accessToken, dispatch]);

  async function updateDeviceId() {
    var deviceId = await retrieveData("updatedDeviceId");
    if (deviceId == null || deviceId == "") {
      deviceId = uuidv4();
      await storeData("updatedDeviceId", deviceId);
    }
  }

  const showAlertModalPlus = (showPlusModal, highlightMsg, headerMsg, subHeaderMsg, btn1Exists, btn2Exists, btn1Text, btn2Text, btn1TypeAcpt, modelImage, carousel, isBorderNone, btn1BgColor, summaryParagraph, opacityValue, comparisonScreen, fullWidth, footerButtonEnable, gradientButton, largeImage) => {
    setShowPlusModal(showPlusModal)
    setHighlightMsg(highlightMsg)
    setheaderMsg(headerMsg)
    setSubHeaderMsg(subHeaderMsg)
    setBtn1Exists(btn1Exists)
    setBtn2Exists(btn2Exists)
    setBtn1Text(btn1Text)
    setBtn2Text(btn2Text)
    setBtn1TypeAcpt(btn1TypeAcpt)
    setModelImage(modelImage)
    setBtn1Exists(btn1Exists)
    setBtn1Text(btn1Text)
    setCarousel(carousel)
    setisBorderNone(isBorderNone)
    setBtn1BgColor(btn1BgColor)
    setSummaryParagraph(summaryParagraph)
    setOpacityValueLow(opacityValue)
    setComparisonScreen(comparisonScreen)
    setFullWidth(fullWidth)
    setFooterButtonEnable(footerButtonEnable)
    setGradientButton(gradientButton)
    setLargeImage(largeImage)
  }

  const onCancelBtnClickPlusModal = () => {
    const isSignKudzuplus = { isSignUpKudzuplusTrue: false };
    dispatch({ type: 'IS_SIGNUP_KUDZU_PLUS_TRUE', payload: isSignKudzuplus });
    const data = { welcomeCarouselSkipValue: true };
    dispatch({ type: 'WELOCME_CAROUSEL_SKIP', payload: data })

    document.body.classList.add('light-theme');
    document.body.classList.remove('dark-theme');

    setIsWelcomeCarouselModalOpen(false);
    showAlertModalPlus(false, t("thanks"), t('+Kudzu+membershipheader'), "", true, true, t('Learn_More'), t('No_Thanks'), true, require('../../../assets/kudzu-plus-images/KudzuPluseLogo.png'), "", true, "#262B3A", t('first_three_months_charged_automatically'), true, '', false, false, true, true);
    setIsMobileVerificationModalOpen(true);
  }

  const onAcptBtnClickPlusModal = () => {
    logFirebaseEvents("Home", "Kudzu_Plus_Learn_More_Clicked", "Kudzu_Plus_Learn_More_Clicked", "", "");
    setShowPlusModal(false)
    const currentPath = { currentPathFromStore: currentpath.pathname };
    dispatch({ type: 'CURRENT_LOCATION', payload: currentPath });
    setShowCarouselScreensShow((prev) => !prev);
    const data = { kudzuFlowFrom: t('fromSignUp') };
    dispatch({ type: 'KUDZU_PLUS_FROM', payload: data });
  }

  const closeModelPlus = () => {
    document.body.classList.add('light-theme');
    document.body.classList.remove('dark-theme');
    setShowPlusModal(false);
    setShowCarouselScreensShow(false);
    setIsMobileVerificationModalOpen(true);
  }

  useEffect(() => {
    debugger
    const kudzuPlusSetForCookies = `kudzuPlusTrueFromCookies`;
    const kudzuPlusTrueFromCookies = Cookies.get(kudzuPlusSetForCookies) === 'true';
    if(kudzuPlusTrueFromCookies){
      const isKudzuPlusAccount = { kudzuPlusTrue: true };
      dispatch({ type: 'KUDZU_PLUS_TRUE', payload: isKudzuPlusAccount });
    }
    else{
    const isSignKudzuplus = { isSignUpKudzuplusTrue: false };
    dispatch({ type: 'IS_SIGNUP_KUDZU_PLUS_TRUE', payload: isSignKudzuplus });
    const data = { welcomeCarouselSkipValue: false };
    dispatch({ type: 'WELOCME_CAROUSEL_SKIP', payload: data })
    const isKudzuPlusAccount = { kudzuPlusTrue: false };
    dispatch({ type: 'KUDZU_PLUS_TRUE', payload: isKudzuPlusAccount });
   }
  }, [])



  const kudzuplusAvailable = async (handleSkipClickedval) => {
    debugger;
    setIsLoading(true);
    try {
      const headers = {
        "Content-Type": "application/json",
      }
      const response = await GetRequest(SIGN_UP_KUDZUPLUS_CHECK + `?appId=${appConfigData.CLIENT_ID}`, headers);
      let responseObj = JSON.parse(response);
      // const data = await response.json();
      if (responseObj.ResponseCode == STATUS_SUCCESS_CODE) {
        setIsLoading(false);
        if (responseObj.Response.isKudzuPlusAvailable === true) {
          const isSignKudzuplusData = { isSignUpKudzuplusTrueData: responseObj.Response.isKudzuPlusAvailable };
          // const isSignKudzuplusData = { isSignUpKudzuplusTrueData: true };
          dispatch({ type: 'IS_SIGNUP_KUDZU_PLUS_TRUE_DATA', payload: isSignKudzuplusData });

          const isSignKudzuplusTrialTrue = { isSignUpKudzuplusTrial: responseObj.Response.isTrial };
          dispatch({ type: 'IS_SIGNUP_KUDZU_PLUS_TRIAL', payload: isSignKudzuplusTrialTrue });

          setIsWelcomeCarouselModalOpen(false);
          if (!handleSkipClickedval) {
            if (responseObj.Response.isTrial) {
              showAlertModalPlus(true, t("thanks"), t('Kudzu+membershipheader'), "", true, true, t('Learn_More'), t('No_Thanks'), true, require('../../../assets/kudzu-plus-images/K-plus-logo.png'), "", true, "#262B3A", addLineBreaks(t('first_three_months_charged_automatically')), true, '', false, false, true,  true);
            } else {
              showAlertModalPlus(true, t("thanks"), t('Kudzu+membershipheader'), "", true, true, t('Learn_More'), t('No_Thanks'), true, require('../../../assets/kudzu-plus-images/KudzuPluseLogo.png'), "", true, "#262B3A", addLineBreaks(t('first_three_months_charged_automatically')), true, '', false, false, true,  true);
            }
          } else {
            // User came from landing carousel, skip Kudzu+ and go to access code check
            getIsAccessCodeFeatureEnabled();
          }

        } else {
          setIsWelcomeCarouselModalOpen(false);
          getIsAccessCodeFeatureEnabled();
        }
      }
      else {
        setIsLoading(false);
        setTimeout(() => {
          const arrMessages = responseObj.Messages;
          const message = arrMessages[0];
          const displayText = message.DisplayText;
          console.log(displayText);
        }, 500);
      }
    } catch (error) {
      console.error("Error during API call:", error);
    }
  };

  const handleStepTwoClick = () => {
    setSteps(2);
  }

  const handleSteps = () => {
    setSteps(1);
  };


  const kudzuPlusSignUpDataTrue = useSelector(state => state.isSignUpKudzuplusTrueData);

  const handleSignUpAccept = () => {
    const isSignKudzuplus = { isSignUpKudzuplusTrue: true };
    dispatch({ type: 'IS_SIGNUP_KUDZU_PLUS_TRUE', payload: isSignKudzuplus });

    if (isSignKudzuplus) {
      debugger
      document.body.classList.add('dark-theme');
      document.body.classList.remove('light-theme');
    } else {
      document.body.classList.add('light-theme');
      document.body.classList.remove('dark-theme');
    }
    setShowCarouselScreensShow(false);
    setIsMobileVerificationModalOpen(true);
  };


  const handleisSignUpCancel = () => {
    setShowCarouselScreensShow(false);
    const isSignKudzuplus = { isSignUpKudzuplusTrue: false };
    dispatch({ type: 'IS_SIGNUP_KUDZU_PLUS_TRUE', payload: isSignKudzuplus });
    document.body.classList.add('light-theme');
    document.body.classList.remove('dark-theme');
    setIsMobileVerificationModalOpen(true);
  };

  const signUpkudzuPlusTrue = useSelector(state => state.isSignUpKudzuplusTrue);
  const mobileVerificationRef = useRef(null);
  const isContinueDisabled =  steps === 1 ? !isSignupPhoneValid || !phScreenAgreeTerms : !phScreenAgreeTerms;
  const continueButtonClasses = `font-hanken-grotesk sm:font-bold font-[600] lg:text-[18px] md:text-[17px] sm:text-[13px] text-[14px] ${isContinueDisabled ? 'text-[var(--twofac-modal-btn-clr-disabled)] cursor-not-allowed' : 'text-[var(--twofac-modal-btn-clr)] cursor-pointer'} ${isContinueDisabled ? 'opacity-[40%]' : ''} flex items-center`;


  const handleMobileVerificationContinue = () => {
    if (mobileVerificationRef.current && mobileVerificationRef.current.handleContinue) {
      mobileVerificationRef.current.handleContinue();
    }
  };

  const handlePhoneValidityChange = (value, isValid) => {
    setIsSignupPhoneValid(Boolean(value) && Boolean(isValid));
  };



  const getIsAccessCodeFeatureEnabled = async () => {
    try {
      const deviceId = await retrieveData("updatedDeviceId");
      const headers = await GetApiHeadersWithOutBearer(deviceId);
      setIsLoading(true);
      const reqObj = {
        appID: appConfigData.CLIENT_ID,
        type: "signupaccesscode",
      };
      var response = await PostRequest(SIGN_UP_FEATURE, reqObj, headers);
      var responseObj = JSON.parse(response);
      setIsLoading(false);
      if (responseObj.ResponseCode == STATUS_SUCCESS_CODE) {
        if (responseObj.Response.enabled) {
          setIsAccessCodeModalOpen(true);
        } else {
          setIsAccessCodeModalOpen(false);
          // niharika
          setIsMobileVerificationModalOpen(true);
        }
      } else {
        setTimeout(() => {
          var arrMessages = responseObj.Messages;
          var message = arrMessages[0];
          var displayText = message.DisplayText;
          // setError(displayText)
        }, 500);
      }
    } catch (error) {
      setIsMobileVerificationModalOpen(true);
    }
  };

  const getAgreementsBasedOnType = async (selectedAgreementType) => {
    const deviceId = await retrieveData("updatedDeviceId");
    const headers = await GetApiHeadersWithBearer(deviceId, accessTokenToApi);
    setIsLoading(true);

    let finalUrl =
      PROGRAM_CONTENT +
      "?accountType=64&language=en&contentType=" +
      selectedAgreementType.url +
      "&programKey=200";
    var response = await GetRequest(finalUrl, headers);
    var responseObj = JSON.parse(response);
    setIsLoading(false);
    if (responseObj.ResponseCode == STATUS_SUCCESS_CODE) {
      setPolicyURL(responseObj.Response.Data);
    } else {
      setTimeout(() => {
        var arrMessages = responseObj.Messages;
        var message = arrMessages[0];
        var displayText = message.DisplayText;
        // setError(displayText)
      }, 500);
    }
  };

  const openLoginModalOpen = () => {
    login("/");
  };
  const registerBrowser = async (accessToken) => {
    await updateDeviceId();
    const deviceId = await retrieveData("updatedDeviceId");
    setIsLoading(true);
    let headers = await GetApiHeadersWithBearer(deviceId, accessToken);

    var model = "";
    const userAgent = window.navigator.userAgent.toLowerCase();

    if (userAgent.includes("macintosh")) {
      model = "MacBook";
    } else if (userAgent.includes("windows")) {
      model = "Windows PC";
    } else if (userAgent.includes("android")) {
      model = "Android";
    } else if (userAgent.includes("ios")) {
      model = "ios";
    }

    let request = {
      DeviceID: deviceId,
      DeviceToken: deviceId,
      DeviceOS: "web",
      Model: model,
    };

    var response = await PostRequest(POST_REGISTER_FCM_TOKEN(isB2c), request, headers);
    let responseObj = JSON.parse(response);

    if (responseObj.ResponseCode === STATUS_SUCCESS_CODE) {
      if (responseObj.Response.IsVerified) {
        if(B2C_enabled) {
          const decodedToken = jwtDecode(accessTokenToApi);
          if("is_mfa_verified" in decodedToken) {
            if(decodedToken?.is_mfa_verified) {
              const twoFactAuthenticationDone = { twoFactAuthenticationDone: true }
              dispatch({ type: 'TWOFACT_DONE', payload: twoFactAuthenticationDone });
            }
          }
        }
        callPostLoginAPI(true);
        // checkCipStatus(true);
      } else {
        setIsLoading(false);
        setTimeout(() => {
          setshow2faSelection(true);
        }, 1000);
        // callGenerateOtp();
        closeResetSuccessModal();
      }
    } else {
      setIsLoading(false);
      var arrMessages = responseObj.Messages;
      if (arrMessages.length > 0) {
        var messageObject = arrMessages[0];
        const message = messageObject.DisplayText;
      }
    }
  };

  async function callGenerateOtp(otpGeneratiionType) {
    if (loginTyagainCount > 4) {
      setIsLoginModalOpen(false);
      setTimeout(() => {
        setLoginOtpErrorMessage(t("exceeded_max_limit"));
        setIsLoginModalOpen(true);
      }, 200);

      return;
    }
    setIsLoading(true);
    const deviceId = await retrieveData("updatedDeviceId");
    var headers = await GetApiHeadersWithBearer(deviceId, accessTokenToApi);
    var cardKey = 0;
    var finalUrl = GENERATE_OTP + "?CardKey=" + cardKey;
    var object = {
      SessionKey: sessionKey,
      ActionType: actionType,
      DeviceID: deviceId,
    };
    if (otpGeneratiionType !== undefined && otpGeneratiionType !== null) {
      object.IsEmail = otpGeneratiionType == "Email" ? true : false;
    }

    const response = await PostRequest(finalUrl, object, headers);
    let responseObj = JSON.parse(response);
    if (responseObj.ResponseCode === STATUS_SUCCESS_CODE) {
      setLoginOtpErrorMessage("");

      setIsLoginModalOpen(true);
      setTimeout(() => {
        // setSessionKey(responseObj.Response.SessionKey)
        setIsLoginModalOpen(true);
        const loginSessionPayLoad = {
          loggedSessionKey: responseObj.Response.SessionKey,
        };
        dispatch({ type: LOGIN_SESSION_KEY, payload: loginSessionPayLoad });
        const tryAgainAccount = loginTyagainCount + 1;
        setLoginTryAgainCount(tryAgainAccount);
        setShowPassCodeExpire(true);
        setShowValidationMessage(false);
        setIsLoading(false);
        showTryAgain();
      }, 1000);
    } else {
      setIsLoading(false);
      var arrMessages = responseObj.Messages;
      var message = arrMessages[0];
      var displayText = message.DisplayText;

      setLoginOtpErrorMessage(displayText);
      setIsLoginModalOpen(true);
    }
  }

  async function verifyOtp(isTrusted, otp) {
    var object = undefined;
    setIsLoading(true);
    let otpValue = otp;
    const deviceId = await retrieveData("updatedDeviceId");
    object = {
      ActionType: actionType,
      SessionKey: sessionKey,
      OTP: otp,
      DeviceID: deviceId,
      IsTrustedDevice: isTrusted,
    };

    var headers = await GetApiHeadersWithBearer(deviceId, accessTokenToApi);
    var cardKey = 0;
    var finalUrl = TWO_AUTH_VERIFY_OTP + "?CardKey=" + cardKey;
    PostRequest(finalUrl, object, headers).then((response) => {
      var responseObj = JSON.parse(response);

      if (responseObj.ResponseCode !== STATUS_SUCCESS_CODE) {
        var arrMessages = responseObj.Messages;
        const message = arrMessages[0];
        const displayText = message.DisplayText;
        setIsLoading(false);
        setLoginOtpErrorMessage(displayText);
        setIsLoginModalOpen(true);
      } else {
        const twoFactAuthenticationDone = { twoFactAuthenticationDone: true };
        dispatch({ type: "TWOFACT_DONE", payload: twoFactAuthenticationDone });

        callPostLoginAPI(isTrusted);

        //  checkCipStatus(isTrusted);

      }
    });
  }
  function showTryAgain() {
    setTimeout(() => {
      setIsTryAgain(true);
    }, 30000);
  }

  async function checkCipStatus(accessTokenToApi) {
    const deviceId = await retrieveData('updatedDeviceId');
    var headers = await GetApiHeadersWithBearer(deviceId, accessTokenToApi);
    var object = {}

    setIsLoading(true);
    const cipUrl = GET_CIP_STATUS;


    // const response = await PostRequest(cipUrl, object, headers);
    const response = await GetRequest(cipUrl, headers);
    let responseObj = JSON.parse(response);
    if (responseObj.ResponseCode === STATUS_SUCCESS_CODE) {
      setIsLoading(false);
      console.log('CIP status updated successfully', responseObj);
      dispatch({ type: 'SET_IS_KBA_AVAILABLE', payload: responseObj.Response?.isKBAAvailable });
      const enrollStatus = responseObj.enrollStatus;
      if (responseObj.Response?.enrollStatus == ENROLL_STATUS_APP) {
        //callPostLoginAPI(isTrusted);
        registerBrowser(accessTokenToApi);
      } else if (responseObj.Response?.enrollStatus == ENROLL_STATUS_REV) {
        showAlertModal(true, t("Hold_tight"), t("Under_review_Text"), t("Team_verifying_Text"), true, false, t('ok'), "", true, require('../../../assets/images/exclimation_1x.png'));
      }
      else if (responseObj.Response?.enrollStatus == ENROLL_STATUS_PEN) {
        if (responseObj.Response?.cipFlow == IDOLOGY_CAMEL_CASE) {
          dispatch({ type: 'CIP_FLOW_IDOLOGY', payload: { cipFlowResp: responseObj.Response } });
          navigate('/idology')
        }
        else {
          setIsLoading(false);
          navigateToCIPDocumentUploadeScreen(responseObj.Response)
        }
      }
      else if (responseObj.Response?.enrollStatus == ENROLL_STATUS_DEC) {
        showAlertModal(
          true,
          t("We're sorry."),
          t("Unable_to_meet_our_approval"),
          <span style={{ fontSize: '0.9em' }} className="text-[var(--modal-text-heading-clr)] ">
            {t("Please_contact")}&nbsp;
            <span onClick={() => { window.open(CONTACT_US_URL, "_blank"); }} style={{ color: '#779CE5', fontSize: '0.9em' }}>{t("Customer_Care")}</span>&nbsp;
            {t("Further_assistance")}
          </span>,
          true,
          false,
          t('ok'),
          "",
          true,
          require('../../../assets/images/profileError.png')
        );
      }
    } else {
      setIsLoading(false);
      var arrMessages = responseObj.Messages;
      var message = arrMessages[0];
      var displayText = message.DisplayText;
      showAlertModal(true, t("alert"), displayText, "", true, false, t('ok'), "", true, require('../../../assets/images/profileError.png'));
    }
  }

  function navigateToCIPDocumentUploadeScreen(cipRespsone) {
    dispatch({ type: 'CIP_STATUS_REFER', payload: { cipReferResponse: cipRespsone } });
    navigate('/CipDocumentUploadScreen')
  }

  async function callPostLoginAPI(isTrusted) {
    setIsLoading(true);
    var url = POST_LOGIN + "includeCards=true";
    try {
      // });
      const deviceId = await retrieveData("updatedDeviceId");
      let headers = await GetApiHeadersWithBearer(deviceId, accessTokenToApi);
      const response = await GetRequest(url, headers);
      if (response) {
        var responseObj = JSON.parse(response);
 
        if (responseObj.ResponseCode !== STATUS_SUCCESS_CODE) {
          setIsLoading(false);
          var arrMessages = responseObj.Messages;
          var message = arrMessages[0];
          var displayText = message.DisplayText;
          setLoginOtpErrorMessage(displayText);
          setIsLoginModalOpen(true);
          // show error to user
        } else {
          global.isLoggedIn = true;
          if (responseObj.Response.Profile !== undefined) {
            console.log(responseObj.Response, "login data of user")
            var language = responseObj.Response.Profile.PreferredLanguage;
            const userLanguagePayload = { userLanguage: language };
            dispatch({
              type: "UPDATE_USER_LANGUAGE",
              payload: userLanguagePayload,
            });
 
            var userpreferredName = responseObj.Response.Profile.PreferredName;
            console.log("userpreferredName", userpreferredName)
            dispatch({ type: "UPDATE_PREFERRED_NAME", payload: { preferredName: userpreferredName } })
 
            const UserProfilePayload = { userProfile: JSON.stringify(responseObj.Response.Profile) };
            dispatch({ type: 'UPDATE_USER_PROFILE', payload: UserProfilePayload });
          }
          if (responseObj.Response.Cards !== undefined && responseObj.Response.Cards.length > 0) {
            if (responseObj.Response.Cards.length > 0) {
              
              const externalSvaId = responseObj.Response.Cards[0].ExternalSVAID;
              const promoKey = responseObj?.Response?.Promos?.[0]?.PromoKey;
              const id = promoKey + '_' + externalSvaId;
              const existingIds = Cookies.get('KUDZU_UPGRADE_PROMPTS_SHOWN_USERS');
              var existingIdsArray = []
              if (existingIds != undefined && existingIds != "") {
                existingIdsArray = JSON.parse(existingIds)
              }
              if (!existingIdsArray.includes(id)) {
                  existingIdsArray.push(id)
                //home
                const showHomeupgradePromptHome = `freeTrial_modal_home${responseObj.Response.Cards[0].CardKey}`;
                Cookies.set(showHomeupgradePromptHome, 'false', { expires: 1825 });
                //depositmoney
                const carouselHideForSetupDdVal = `carouselHideForSetupDd${responseObj.Response.Cards[0].CardKey}`;
                Cookies.set(carouselHideForSetupDdVal, 'false', { expires: 1825 });
                //transfer money
                const showHomeupgradePromptTransferMoney = `freeTrial_modal_TransferMoney${responseObj.Response.Cards[0].CardKey}`;
                Cookies.set(showHomeupgradePromptTransferMoney, 'false', { expires: 1825 });
 
                //climb
                const showHomeupgradePromptClimbg = `freeTrial_modal_Climb${responseObj.Response.Cards[0].CardKey}`;
                Cookies.set(showHomeupgradePromptClimbg, 'false', { expires: 1825 });
 
                //storing id array string
                const savedExistingIds = JSON.stringify(existingIdsArray);
                Cookies.set('KUDZU_UPGRADE_PROMPTS_SHOWN_USERS', savedExistingIds, { expires: 1825 });
 
              }
            }
 
            const userCardsPayload = {
              userCards: JSON.stringify(responseObj.Response.Cards),
            };
            dispatch({ type: "UPDATE_USER_CARDS", payload: userCardsPayload });
 
            //FORM TO HERE
 
            const data = responseObj?.Response
            console.log("responsed data is", data);
            const ShowUpgradePrompts = showPrompt(data);
            dispatch({ type: "LOGGED_IN_RESPONSE", payload: { loggedInResponse: JSON.stringify(responseObj.Response) } });

            //for smione user
            const smioneIsTrue = isSmiOneAccountTrue(data);
            dispatch({ type: "SMIONE_ACCOUNT_TRUE", payload: { smiOneAccountTrue: smioneIsTrue  } });

            const hasKudzuCardTRUE = hasKudzuCardTrue(data);
            dispatch({ type: "HAS_KUDZU_CARD", payload: { hasKudzuCard: hasKudzuCardTRUE  } });
           
            dispatch({ type: "SHOW_PROMPT_TRUE", payload: { ShowPromptsTrue: ShowUpgradePrompts }, });
            const hasSubscription = responseObj?.Response?.Subscription && Object.keys(responseObj?.Response?.Subscription).length > 0
            const isKudzuPlusAccount = {
              kudzuPlusTrue: hasSubscription == true ? true : false
            };
            dispatch({ type: 'KUDZU_PLUS_TRUE', payload: isKudzuPlusAccount });

            if (isKudzuPlusAccount.kudzuPlusTrue) {
              const kudzuPlusSetForCookies = `kudzuPlusTrueFromCookies`;
              Cookies.set(kudzuPlusSetForCookies, true, { expires: 1825 });
            }
            else {
              const kudzuPlusSetForCookies = `kudzuPlusTrueFromCookies`;
              Cookies.remove(kudzuPlusSetForCookies);
            }
            const userCardsArray = responseObj?.Response?.Cards
             
            
          if (responseObj?.Response?.ShowKudzuPlusPromoAfterCancellation === true) {
            const cardKey = responseObj?.Response?.Cards?.[0]?.CardKey;
            if (cardKey) {
              const updateUrl = SVA_CONFIGURATION_UPDATE(cardKey);
              try {
                const updateHeaders = await PostRequest(updateUrl,"" ,headers);
                
              } catch (updateError) {
               
              }
            }
          }

          // Trigger secured credit popover if conditions are met
          responseObj?.Response?.ShowSecuredCreditPromo === true &&
            (() => {
              const spendingCard = responseObj?.Response?.Cards?.find(card => 
                card.AccountTypeBit63 === CHECKING_CARD_CODE
              );
              return spendingCard?.AllowSecuredCredit === true;
            })() &&
            dispatch({ type: SHOW_SECURED_CREDIT_POPOVER });

          if (selectedCardDetails == null) {
              dispatch({
                type: "SELECTED_USER_CARD_DETAILS",
                payload: { selectedCardDetails: responseObj.Response.Cards[0] },
              });
            }
          }
          if (
            responseObj.Response.Activities !== undefined &&
            responseObj.Response.Activities.length > 0
          ) {
            const userActivitiesPayload = {
              userActivities: JSON.stringify(responseObj.Response.Activities),
            };
            dispatch({
              type: "UPDATE_USER_ACTIVITIES",
              payload: userActivitiesPayload,
            });
          }
          let cards = responseObj.Response.Cards;
          if (cards.find((item) => item.AccountTypeBit63 == SAVING_CARD_CODE)) {
            const savingsAvailablePayload = { savingsAccontAvailable: true };
            dispatch({
              type: "SAVINSGS_AVAILABLE",
              payload: savingsAvailablePayload,
            });
          } else {
            const savingsAvailablePayload = { savingsAccontAvailable: false };
            dispatch({
              type: "SAVINSGS_AVAILABLE",
              payload: savingsAvailablePayload,
            });
          }
 
          const loginPayload = { isLoggedIn: true };
          dispatch({ type: "LOG_IN", payload: loginPayload });
 
          if (isTrusted) {
            const trustedDevicePayload = { trustedDevice: true };
            dispatch({ type: "TRUSTED_DEVICE", payload: trustedDevicePayload });
          }
          setIsLoading(false);
          const sessionTimeoutDurationMinutes = 60;
          sessionStorage.setItem(
            "sessionTimeoutDuration",
            String(sessionTimeoutDurationMinutes)
          );
          window.history.replaceState(null, "", "");
          if (
            responseObj.Response.Activities != undefined &&
            responseObj.Response.Activities.length > 0
          ) {
            responseObj.Response.Activities.sort(function (a, b) {
              return parseInt(a.Order) - parseInt(b.Order);
            });
            switch (responseObj.Response.Activities[0].ActivityTypeCode) {
              case ACTIVITY_TYPE_E_SIGN:
                const isAcceptAgreement = { isAcceptAgreement: true };
                dispatch({
                  type: "IS_ACCEPT_AGREEMENT",
                  payload: isAcceptAgreement,
                });
                const activeCards = {
                  activityCards: JSON.stringify(responseObj.Response.Activities),
                }
                dispatch({ type: "GET_ACTIVITY_CARDS", payload: activeCards });
                navigate("/AcceptTerms");
                return;
              default:
                break;
            }
          }
          const isAcceptAgreement = { isAcceptAgreement: false };
          dispatch({ type: "IS_ACCEPT_AGREEMENT", payload: isAcceptAgreement });
         
          
           
           checkAndNavigateToPath();
 
         
        }
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Error in API call:", error);
    }
  }
  
  async function checkAndNavigateToPath() {
  
    const path = await retrieveData("DEEPLINK_PATH");
    if (path != "" && path != null && path.toLowerCase() != "/home") {
      storeData("DEEPLINK_PATH", "");
      const savedDeeplinkPath = { deepLinkPath: "" };
      dispatch({ type: "DEEPLINK_PATH", payload: savedDeeplinkPath });
      if (
        path.toLowerCase().includes("viewcard") ||
        path.toLowerCase().includes("changepin")
      ) {
        navigate("/CardServices/CardActionScreen");
      } else {
        if(path === "/link-smione-card/Onboard"){
          navigate("/smione-card/Onboard")
          
        }else{
         navigate(path);
        }

       
      }
    } else {
     
      navigate("/home")
     

     
      
    }
  }

 
  const closeLoginModal = () => {
    setIsLoginModalOpen(false);
  };

  const closeTrustDeviceLoginModal = () => {
    setLoginTrustDeviceOpen(false);
    setIsLoginModalOpen(true);
  };

  const openOTPVerifyModal = () => {
    closeMobileVerificationModal();
    setIsOTPVerifyModalOpen(true);
  };

  const closeOTPVerifyModal = () => {
    setIsOTPVerifyModalOpen(false);
  };
  const closeAuthModal = () => {
    setAuthUserCodeModelOpen(false);
  };
  const closeExistingErrModal = () => {
    setExistingErrorModalOpen(false);
    
  };

 const closeSMIOneExistingErrModla =() =>{
    setExistingErrorModalOpen(false);
    setIsMobileVerificationModalOpen(true);
  }

  //auth user flow
  const handleAuthUserFlow = (code) => {
    setIsOTPVerifyModalOpen(false);
    setAuthUserCodeModelOpen(true);
  };
  const handleExistingErrorModal = (canContinue) => {
    setIsOTPVerifyModalOpen(false);
    setExistingErrorModalOpen(true);
    if(canContinue){
       setCanContinue(true);
    }
  };

 
  const clickedOnSignupCheckbox = (messgage) => {
    setSingupCheckBoxMessage(messgage);
  };
  const handleUserSuccess = () => {
    setAuthUserCodeModelOpen(false);
    const isMobileVerifiedPayload = { isMobileVerifed: true };
    dispatch({ type: "MOBILE_VERIFIED", payload: isMobileVerifiedPayload });
    navigate("/Onboard");
  };

  const handleTryAgainExistingErr = () => {
    setphScreenAgreeTerms(false);
    setExistingErrorModalOpen(false);
    setIsMobileVerificationModalOpen(true);
  };
  ////login flow
  const handleLoginVerifyDeviceClick = (code) => {
    logFirebaseEvents("Pre_Login", "Verify_Btn_Clicked", "Verify_Btn_Clicked", "");
    setIsLoginModalOpen(false);
    setLoginOTP(code);
    setLoginTrustDeviceOpen(true);
  };
  const loginTrustDeviceClicked = (isTrusted) => {
    const isDeviceTrustedPayload = { isLoginDeviceTrusted: isTrusted };
    if (isTrusted) {
      logFirebaseEvents("Trust_and_Non Trust", "Trust_Cliked", "Trust_Cliked", "", "");
    } else {
      logFirebaseEvents(
        "Trust_and_Non Trust",
        "Don'tTrust_Cliked",
        "Don'tTrust_Cliked",
        ""
      );
    }
    dispatch({
      type: "UPDATE_LOGIN_DEVICE_TRUSTED",
      payload: isDeviceTrustedPayload,
    });

    setIsLoginModalOpen(false);
    setLoginTrustDeviceOpen(false);
    verifyOtp(isTrusted, loginOTP);
  };
  const handleLoginOtpTryAgain = (otp) => {
    logFirebaseEvents("Pre_Login", "Try_Again_Clicked_In_Verify", "Try_Again_Clicked_In_Verify", "");
    setLoginOTP(otp);
    setIsLoginModalOpen(false);
    setshow2faSelection(false);
    callGenerateOtp(undefined);
  };

  ////forgorpasswrd flow

  // Verify Email Modal

  const openVerifyEmailModal = () => {
    // closeLoginModal();
    setIsVerifyEmailModalOpen(true);
  };

  const closeForgotPasswordInitialScreen = () => {
    logFirebaseEvents("Reset_Password", "Close_Clicked", "Close_Clicked", "", "");
    setIsVerifyEmailModalOpen(false);
    login("/");
  };
  const closeVerifyEmailModal = () => {
    setIsVerifyEmailModalOpen(false);
  };

  const handleModalOnImReadyButtonClick = () => {
    logFirebaseEvents("Reset_Password", "Email_Submited", "Email_Submited", "", "");
    closeVerifyEmailModal();
    openSecurityCheckModal();
  };
  const handleSignUpClickInEmailModal = () => {
    logFirebaseEvents("Reset_Password", "SignUp_Clicked", "SignUp_Clicked", "", "");
    closeVerifyEmailModal();
    // OpenMobileVerificationModal();
    setIsWelcomeCarouselModalOpen(true);
  };

  // Security check modal
  const [isSecurityCheckModalOpen, setIsSecurityCheckModalOpen] =
    useState(false);

  const openSecurityCheckModal = () => {
    setIsSecurityCheckModalOpen(true);
  };

  const closeSecurityCheckModal = () => {
    logFirebaseEvents("Reset_Password", "VerifyOTP_Close", "VerifyOTP_Close", "", "");
    setIsSecurityCheckModalOpen(false);
  };

  const handleModalOnVerifyClick = () => {
    closeSecurityCheckModal();
    openResetYourPassModal();
  };

  const handleSignUpClickInSecurityCheckModal = () => {
    logFirebaseEvents("Reset_Password", "SignUp_Clicked", "SignUp_Clicked", "", "");
    closeSecurityCheckModal();
    // OpenMobileVerificationModal();
     setIsWelcomeCarouselModalOpen(true);
  };

  // Reset Password modal
  const [isResetYourPassModalOpen, setIsResetYourPassModalOpen] =
    useState(false);

  const openResetYourPassModal = () => {
    setIsResetYourPassModalOpen(true);
  };

  const closeResetYourPassModal = () => {
    setIsResetYourPassModalOpen(false);
  };

  const handleModalOnLoginClick = () => {
    closeResetYourPassModal();
    openResetSuccessModal();
  };

  // Reset Success modal
  const [isResetSuccessModalOpen, setIsResetSuccessModalOpen] = useState(false);

  const openResetSuccessModal = () => {
    setIsResetSuccessModalOpen(true);
  };

  const closeResetSuccessModal = () => {
    setIsResetSuccessModalOpen(false);
  };

  const openAccessCodeModal = () => {
    setIsAccessCodeModalOpen(true);
  };

  const closeAccessCodeModal = () => {
    // setAccessCode("")
    setIsAccessCodeModalOpen(false);
    login("/");
  };
  const openAccessCodeErrorModal = () => {
    setIsAccessCodeErrorModalOpen(true);
    setIsAccessCodeModalOpen(false);
  };

  const closeAccessCodeErrorModal = () => {
    // login("/")
    setIsAccessCodeErrorModalOpen(false);
    setIsAccessCodeModalOpen(true);
  };
  const openAccessCodeNoWorriesModal = () => {
    logFirebaseEvents("Access_code", "Don'Don't_Have_Access_Clicked", "Don'Don't_Have_Access_Clicked", "", "");
    setIsAccessCodeNoWorriesModalOpen(true);
    setIsAccessCodeModalOpen(false);
  };

  const closeAccessCodeNoWorriesModal = () => {
    // login("/")
    setIsAccessCodeNoWorriesModalOpen(false);
    setIsAccessCodeModalOpen(true);
  };

  const handleNavigation = () => {
    const url = "https://share.hsforms.com/12cQSOZyLRMqVP5qxsAg3zgorzxu"
    window.location.replace(url);
  };

  const BannerImage = {
    height: "100vh",
    backgroundImage: `url(${Banner})`,
    backgroundSize: "cover", // This makes the image cover the entire container
    backgroundPosition: "center",
    maxWidth: "100%",
  };
  const BannerBackground = {
    background: "#262B3A",
    backgroundSize: "cover", // This makes the image cover the entire container
    backgroundPosition: "center",
    maxWidth: "100%",
  };

  const handleClick = (type) => {
    setShowPolicys((prevState) => {
      if (type === "privacy") {
        return "privacy";
      } else if (type === "agreement") {
        return "agreement";
      } else if (type === "deposit") {
        return "deposit";
      } else if (type === "savings") {
        return "savings";
      } else if (type === "electronic") {
        return "electronic";
      } else {
        return "terms";
      }
    });
  };

  const [accessCode, setAccessCode] = useState("");
  const [accessCodeError, setAccessCodeError] = useState("");
  const [isVerifiedCode, setIsVerifiedCode] = useState(false);

  const verifyAccessCode = async () => {
    try {
      const deviceId = await retrieveData("updatedDeviceId");
      const headers = await GetApiHeadersWithOutBearer(deviceId);
      setIsLoading(true);
      const reqObj = {
        appID: appConfigData.CLIENT_ID,
        code: accessCode.toUpperCase(),
      };
      var response = await PostRequest(VERIFY_ACCESS_CODE, reqObj, headers);
      var responseObj = JSON.parse(response);
      setIsLoading(false);
      if (responseObj.ResponseCode == STATUS_SUCCESS_CODE) {
        if (responseObj.Response.Success) {
          dispatch({
            type: "UPDATE_SIGNUP_ACCESS_CODE",
            payload: { signUpAccessCode: accessCode.toUpperCase() },
          });
          setIsVerifiedCode(true);
          OpenMobileVerificationModal();
        }
      } else {
        setTimeout(() => {
          var arrMessages = responseObj.Messages;
          var message = arrMessages[0];
          var displayText = message.DisplayText;
          setAccessCodeError(displayText);
          openAccessCodeErrorModal();
        }, 500);
      }
    } catch (error) {
      setAccessCodeError(error.message);
    }
  };

  const showAlertModal = (
    showModel,
    highlightMsg,
    headerMsg,
    subHeaderMsg,
    btn1Exists,
    btn2Exists,
    btn1Text,
    btn2Text,
    btn1TypeAcpt,
    modelImage
  ) => {
    setShowModel(showModel);
    setHighlightMsg(highlightMsg);
    setheaderMsg(headerMsg);
    setSubHeaderMsg(subHeaderMsg);
    setBtn1Exists(btn1Exists);
    setBtn2Exists(btn2Exists);
    setBtn1Text(btn1Text);
    setBtn2Text(btn2Text);
    setBtn1TypeAcpt(btn1TypeAcpt);
    setModelImage(modelImage);
  };

  const closeModel = () => {
    setShowModel(false);
    handleLogout()
  };

  const onAcptBtnClick = async () => {
    setShowModel(false);
    handleLogout()
  };

  const handleLogout = async () => {
    if (accessTokenToApi == undefined || accessTokenToApi == null) {
      return;
    }

    global.isLoggedIn = false
    await logout()
    logoutManually();
    const deviceIdKey = 'updatedDeviceId';
    clearStorageExceptKey(sessionStorage, deviceIdKey);
    clearStorageExceptKey(localStorage, deviceIdKey);
    store.dispatch({ type: 'LOGOUT' });
    const loginPayload = { isLoggedIn: false };
    dispatch({ type: 'LOG_IN', payload: loginPayload });

  }
  const logoutManually = async () => {
    const deviceId = await retrieveData('updatedDeviceId');
    const headers = await GetApiHeadersWithBearer(deviceId, accessTokenToApi);
    var url = END_SESSION(isB2c, appConfigData.AUTH_URL, appConfigData.B2C_END_SESSION_URL, appConfigData.CLIENT_ID, accessTokenToApi, appConfigData.POST_LOGOUT_REDIRECT_URI);
    window.location.replace(url);
  }

  
  // welcome slide Data
  const slidesDataForHome = [
    {
      heading:
        <>
          <p>{t('welcomeTo')} <span className="text-[#2965FB]">{t('kudzu')}</span> </p>
          <p className={`md:pt-5 pt-2`}>
            {t('journetToGrowth')}
          </p>
        </>,
      paragraph: "",
      imageUrl: require('../../../assets/kudzu-plus-images/Bargraph.png')
    },
    {
      heading: <p>
        With an optional <span className="text-[#2965FB]">Kudzu Savings Account</span>, you can keep your money
        safe and earn interest on your balance.
      </p>,
      paragraph: "",
      imageUrl: require('../../../assets/kudzu-plus-images/illo-piggybank.png')
    },
    {
      heading: <p>With features like your toolkit for building money mindfulness
        and smart spending habits, we’re here to support you along the way.</p>,
      paragraph: "",
      imageUrl: require('../../../assets/kudzu-plus-images/umbraleGreen-by-kudzu.png')
    },
    {
      heading: <p className="">And when you use your Kudzu Visa<sup>®</sup> Debit Card or complete one of our learning modules, you’ll earn rewards with{" "}<i>PayPerks<sup className="font-serif-pro">®*</sup></i>.</p>,
      paragraph: "",
      imageUrl: require('../../../assets/kudzu-plus-images/paypers.png'),
      footerText:
        <>
          <p className="mb-2 text-[#262B3A] max-w-[430px] md:text-[11px] sm:text-[10px] text-[14px]">
            Banking services are provided by The Bancorp Bank, N.A., Member FDIC. The Kudzu Visa®
            Debit Card is issued by The Bancorp Bank, N.A., Member FDIC, pursuant to a license from Visa U.S.A.,
            Inc. and may be used everywhere Visa debit cards are accepted.</p>

          <p className="mb-4 max-w-[430px] text-[#262B3A] md:text-[11px] sm:text-[10px] text-[14px]">*The Bancorp Bank, N.A., is issuer of the Kudzu Visa® Debit Card only and does not
            endorse or sponsor the associated products, services or offers from PayPerks®.</p>
        </>
    },

  ];

  const handlewelcomeCarouselSkipClick = () => {
    // debugger
    document.body.classList.add('light-theme');
    const data = { welcomeCarouselSkipValue: true };
    dispatch({ type: 'WELOCME_CAROUSEL_SKIP', payload: data })
    const isSignKudzuplus = { isSignUpKudzuplusTrue: false };
    dispatch({ type: 'IS_SIGNUP_KUDZU_PLUS_TRUE', payload: isSignKudzuplus });
    setHandleSkipClicked(true)
    //  if (isSignKudzuplus) {
    //    document.body.classList.add('dark-theme');
    //    document.body.classList.remove('light-theme');
    //  } else {
    //    document.body.classList.add('light-theme');
    //    document.body.classList.remove('dark-theme');
    //  }
    // dispatch({ type: 'WELOCME_CAROUSEL_SKIP', payload: true })
    // Don't show Kudzu+ when user cancels/skips signup
    kudzuplusAvailable(true) // Pass true to skip Kudzu+ screen
    setIsWelcomeCarouselModalOpen(false);
    setIsMobileVerificationModalOpen(true);
  };

 const hanldleWelcomeSmiOne = async () =>{
  const currentPath = location.pathname;
    if (makeOpenSmiOnborad) {
     return;
   }
 
      const bodyRequest ={
        migrationToken : idFromSmiOne, 
      }
        const deviceId = await retrieveData('updatedDeviceId');
        const headers = await GetApiHeadersWithBearer(deviceId, accessTokenToApi);
        const Url = SMI_ONE_INITIATE_SESSION(appConfigData.CLIENT_ID);
        
        const response = await PostRequest(Url, bodyRequest, headers);
        const responseJson = JSON.parse(response);
        console.log('responseJson',response)
        setIsLoading(true)
        if (responseJson.ResponseCode === STATUS_SUCCESS_CODE) {
          dispatch({
            type: "SMI_ONE_KUDZU_RESPONSE_DATA",
            payload: { smiOneKudzuResponseData: responseJson.Response },
          });
          const MigrateUser = `IdForMigrateUser`;
          Cookies.set(MigrateUser, responseJson.Response.userId, { expires: 1825 });
          startTransition(() => {
        
      
         if(currentPath.toLowerCase() ===  "/signup")
         {
          setIsMobileVerificationModalOpen(true)
         }else{
           setIsWelcomeCarouselModalOpenForSMI(true)
         }

          });
          setIsLoading(false)
        }else{
          var arrMessages = responseJson.Messages;
          var message = arrMessages[0];
          var displayText = message.DisplayText;
          setIsLoading(false)
          setResponseErrorMsg(displayText);
          setShowSmiOneErrorModal(true)
        } 
  }

  const handleSmiOneContinue = () =>{
    dispatch({ type: "RESET_SMI_ONE_LAST_DIGIT_CARD_NO" })
    startTransition(() => {
      setKudzuSmiOneModal(false)
      setIsWelcomeCarouselModalOpenForSMI(false)
      setIsMobileVerificationModalOpen(true);
    });
  }

 

  return (
    <>
      <div className="animate__animated animate__fadeIn ">
        <Header />
        <div className="h-[100vh]" style={BannerImage} />
      </div>

      {/* Access code  modal */}

      {isAccessCodeModalOpen && <Modal
        isOpen={isAccessCodeModalOpen}//isLoginTrustDeviceOpen
        onClose={debounce(closeAccessCodeModal, 100)}
        isLogo={false}
        alignItems={'items-center'}
        isFooter={true}
        button1={
          <p
            className="focus:outline-none  md:w-[700px] sm:w-[450px] w-[100%] mx-auto h-full font-hanken-grotesk  text-white bg-[#30BC89] cursor-pointer flex justify-center sm:justify-between items-center p-4"

          >
            <p className={`${isVerifiedCode ? 'flex' : 'invisible'} flex-row justify-center items-center`} >
              <img src={Check} alt='Early access' className='sm:mr-4 mr-1 h-[20px] w-[20px]' /><span className="sm:font-bold font-[600] lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px]">{t('early_access')}</span>
            </p>
            <button
              type={'submit'}
              onClick={() => {
                if (accessCode.length >= 1) verifyAccessCode()
              }
              }

              className={`${!isVerifiedCode ? 'flex' : 'hidden sm:flex'} flex-row justify-center items-center`} >
              <span className={`sm:font-bold font-[600] lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px] ${accessCode.length === 0 && 'opacity-50'} `}>{t('payPerksBtn')}</span><img src={NextArrow} alt='next' className={`${accessCode.length === 0 && 'opacity-50'} sm:ml-2 ml-1`} />
            </button>
          </p>

        }
        // title={<p className={`${HeadingStyles} sm:block hidden`}>{t('welcome')}</p>}
        title={<p className={`${HeadingStyles} sm:block hidden`}>{t('access_code')}</p>}
        subtitle={
          <div>
            {/* <span className={`${HeadingStyles} sm:hidden`}>{t('welcome')}</span> */}
            <span className={SubHeadingStyles}>{t('access_code_text')}</span>
          </div>}
        content={<div className="md:pt-5 lg:pb-3 md:pb-8 pt-4 pb-4">
          <AccessCode
            openVerificationModal={debounce(OpenMobileVerificationModal, 100)}
            openAccessCodeErrorModal={debounce(openAccessCodeErrorModal, 100)}
            openAccessCodeNoWorriesModal={debounce(openAccessCodeNoWorriesModal, 100)}
            onAccessCodeValid={(val) => setValidAccessCode(val)}
            onAccessCode={(val) => setAccessCode(val)}
            onAccessCodeError={accessCodeError}
            verifyAccessCode={verifyAccessCode}
          />
        </div>}
      />}

      {/* Access code error modal */}
      {isAccessCodeErrorModalOpen && (
        <Modal
          isOpen={isAccessCodeErrorModalOpen} //isLoginTrustDeviceOpen
          onClose={debounce(closeAccessCodeErrorModal, 100)}
          isLogo={false}
          alignItems={"items-center"}
          title={
            <p className={`${HeadingStyles} sm:block hidden`}>{t("oh_no")}</p>
          }
          subtitle={
            <div>
              <span className={`${HeadingStyles} sm:hidden`}>{t("oh_no")}</span>
              <span className={SubHeadingStyles}>{t("invalid_code")}</span>
            </div>
          }
          content={
            <div className="md:pt-5 lg:pb-3 md:pb-8 pt-4 pb-4">
              <div className="flex flex-col gap-20 justify-center ">
                <p className={FailSubHeaderMsgStyles}>
                  {t("please_contact")}
                  {
                    <button
                      onClick={() => {
                        window.open(CONTACT_US_URL, "_blank");
                      }}
                      className="font-hanken-grotesk lg:text-[20px] md:text-[18px] sm:text-[14px] text-[16px] text-[#2965FB] font-semibold cursor-pointer"
                    >
                      {t("signup_customer_care")}
                    </button>
                  }
                  {t("for_access")}
                </p>
                <div className="flex flex-col justify-center items-center w-full">
                  <img
                    src={report}
                    alt="Early access"
                    className="sm:ml-4 ml-1 h-[123px] w-[123px]"
                  />
                </div>
                <button
                  type="button"
                  className="focus:outline-none  w-full font-hanken-grotesk font-[400] lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px] text-white bg-[#2965FB] cursor-pointer flex justify-center items-center p-4"
                  onClick={() => {
                    handleNavigation();
                  }}
                  onKeyDown={(event) => {
                    if (event.key === "Enter") {
                      handleNavigation();
                      event.stopPropagation();
                    }
                  }}
                  autoFocus
                >
                  {t("join_the_waitlist")}
                </button>
              </div>
            </div>
          }
        />
      )}

      {/* Access Code No worries modal */}
      {isAccessCodeNoWorriesModalOpen && (
        <Modal
          isOpen={isAccessCodeNoWorriesModalOpen} //isLoginTrustDeviceOpen
          onClose={debounce(closeAccessCodeNoWorriesModal, 100)}
          isLogo={false}
          alignItems={"items-center"}
          title={
            <p className={`${HeadingStyles} sm:block hidden`}>
              {t("no_worries")}
            </p>
          }
          subtitle={
            <div>
              <span className={`${HeadingStyles} sm:hidden`}>
                {t("no_worries")}
              </span>
              <span className={SubHeadingStyles}>
                {t("kudzu_will_available")}
              </span>
            </div>
          }
          content={
            <div className="md:pt-5 lg:pb-3 md:pb-8 pt-4 pb-4">
              <div className="flex flex-col gap-20 justify-center ">
                <p className="font-hanken-grotesk font-semibold sm:font-[500] sm:text-[14px] md:text-[20px] text-[16px] md:leading-[30px] leading-[24px]">
                  {t("pl_join_our1")}
                  <span
                    className="text-[#2965FB] cursor-pointer"
                    onClick={() => {
                      window.open(
                        "https://www.kudzumoney.com/contact-us",
                        "_blank"
                      );
                      logFirebaseEvents("Join_the_waitlist ", "Contact_Customer_Clicked", "Contact_Customer_Clicked", "", "");
                    }}
                  >
                    {t("support_email")}
                  </span>
                  {t("pl_join_our2")}
                </p>
                <div className="flex flex-col justify-center items-center w-full">
                  <img
                    src={Klogo}
                    alt="Early access"
                    className="sm:ml-4 ml-1 h-[105px] w-[96px]"
                  />
                </div>
                <button
                  type="button"
                  className="focus:outline-none  w-full font-hanken-grotesk font-[400] lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px] text-white bg-[#2965FB] cursor-pointer flex justify-center items-center p-4"
                  onClick={() => {
                    handleNavigation();
                    logFirebaseEvents("Join_the_waitlist ", "Join_Wait_List_Clicked", "Join_Wait_List_Clicked", "");
                  }}
                  onKeyDown={(event) => {
                    if (event.key === "Enter") {
                      handleNavigation();
                      event.stopPropagation();
                    }
                  }}
                  autoFocus
                >
                  {t("join_the_waitlist")}
                </button>
              </div>
            </div>
          }
        />
      )}

      {/* welcome carousel MODAL */}
      {isWelcomeCarouselModalOpen && (
        <Modal
          isOpen={isWelcomeCarouselModalOpen}
          onClose={(debounce(handlewelcomeCarouselSkipClick, 100))}
          defaultCornerRadius={false}
          isLogo={false}
          Fullheight={true}
          bgColor={'bg-[#FEFAEE]'}
          content={
            <div>
              <LandingCarousel 
                onSkipClick={(debounce(handlewelcomeCarouselSkipClick, 100))}
                onKudzuPlusClick={() => (kudzuplusAvailable(true))} 
              />
            </div>
          }
        />
      )}

      {/* Mobile Verfication  MODAL */}

      {isMobileVerificationModalOpen && (
        <Modal
          isOpen={isMobileVerificationModalOpen}
          onClose={closeInitialSignupscreen}
          defaultCornerRadius={false}
          isLogo={steps === 1 ? true : false}
          Fullheight={true}
          showBack={ steps ===1 ? false :true }
          onBack={handleSteps}
          title={steps ===1 ? <p className={HeadingUpdatedStyles}><span className={HeadingStyles}>First, </span>{t('phoneverify_tittle')}</p> : <p className={SubHeadingStyles}><span className="text-[#2965FB]">Terms </span>& Disclosures</p>}
          content={
            <div className={`md:pt-5 ${isFromSmiOne ? 'w-[85%]' : ''} lg:pb-[1rem] md:pb-8 pt-4 pb-4`}>
              <>
              <MobileVerification
                updatemobileTermsChekbox={clickedOnSignupCheckbox}
                ref={mobileVerificationRef}
                openPhoneOTPModal={debounce(openOTPVerifyModal, 100)}
                phScreenAgreeTerms={phScreenAgreeTerms}
                showInput = {steps === 1 ? false : true}
                handleSteps={debounce(handleSteps, 100)}
                showContinue = {false}
                onPhoneChange={handlePhoneValidityChange}
              />
               {steps === 1 ? <p></p> : <><div className="flex items-start gap-2"><p className="text-[var(--modal-text-heading-clr)] lg:text-[13px] md:text-[11px] sm:text-[10px] text-[12px] font-hanken-grotesk font-semibold leading-[18px] sm:leading-[20px] pt-2 sm:pt-5">1.</p><p className="text-[var(--modal-text-heading-clr)] sm:pt-5 pt-2 lg:text-[12px] md:text-[11px] sm:text-[10px] text-[12px] font-hanken-grotesk font-semibold sm:leading-[20px] leading-[18px]">
                {t("By_providing")}
                <span
                  tabIndex="0"
                  onClick={() => {
                    logFirebaseEvents("Phone_Number_Verification", "Kudzu_Privacy_Policy_Clicked", "Kudzu_Privacy_Policy_Clicked", "", "");
                    getAgreementsBasedOnType(agreementType[0]);
                    setShowAgreementsModel(true);
                    setIsMobileVerificationModalOpen(false);
                  }}
                  onKeyDown={(event) => {
                    if (event.key === "Enter") {
                      event.preventDefault();
                      getAgreementsBasedOnType(agreementType[0]);
                      setShowAgreementsModel(true);
                      setIsMobileVerificationModalOpen(false);
                    }
                  }}
                  className="text-[var(--text-clr-blue-sky)] cursor-pointer underline"
                >
                  {t("kudzu_privacy_policy")}
                </span>
                {", "}
                <span
                  tabIndex="0"
                  onClick={() => {
                    logFirebaseEvents("Phone_Number_Verification", "Kudzu_Terms_Of_Services_Clicked", "Kudzu_Terms_Of_Services_Clicked", "", "");
                    getAgreementsBasedOnType(agreementType[1]);
                    setShowAgreementsModel(true);
                    setIsMobileVerificationModalOpen(false);
                  }}
                  onKeyDown={(event) => {
                    if (event.key === "Enter") {
                      event.preventDefault();
                      getAgreementsBasedOnType(agreementType[1]);
                      setShowAgreementsModel(true); 
                      setIsMobileVerificationModalOpen(false);
                    }
                  }}
                  className="text-[var(--text-clr-blue-sky)] cursor-pointer underline"
                >
                  {t("sms_terms_of_service")}
                </span>
                {", "}
                <span
                  tabIndex="0"
                  onClick={() => {
                    logFirebaseEvents("Phone_Number_Verification", "Kudzu_User_Agreement_Clicked", "Kudzu_User_Agreement_Clicked", "", "");
                    getAgreementsBasedOnType(agreementType[3]);
                    setShowAgreementsModel(true);
                    setIsMobileVerificationModalOpen(false);
                  }}
                  onKeyDown={(event) => {
                    if (event.key === "Enter") {
                      event.preventDefault();
                      getAgreementsBasedOnType(agreementType[3]);
                      setShowAgreementsModel(true);
                      setIsMobileVerificationModalOpen(false);
                    }
                  }}
                  className="text-[var(--text-clr-blue-sky)] cursor-pointer underline pr-1"
                >
                  Kudzu User Agreement
                </span>
                {t("and")}
                <span
                  tabIndex="0"
                  onClick={() => {
                    logFirebaseEvents("Phone_Number_Verification", "Bancorp_Notice_Clicked", "Bancorp_Notice_Clicked", "", "");
                    getAgreementsBasedOnType(agreementType[2]);
                    setShowAgreementsModel(true);
                    setIsMobileVerificationModalOpen(false);
                  }} 
                  onKeyDown={(event) => {
                    if (event.key === "Enter") {
                      event.preventDefault();
                      getAgreementsBasedOnType(agreementType[2]);
                      setShowAgreementsModel(true);
                      setIsMobileVerificationModalOpen(false);
                    }
                  }}
                  className="cursor-pointer underline text-[var(--text-clr-blue-sky)] pl-1"
                >
                  {t("bancorp_Notice")}
                </span>
              .</p></div></>}
              {steps === 1 ? <p></p> : <><div className="flex items-start gap-2"><p className="text-[var(--modal-text-heading-clr)] lg:text-[13px] md:text-[11px] sm:text-[10px] text-[12px] font-hanken-grotesk font-semibold leading-[18px] sm:leading-[20px] pt-2 sm:pt-5">2.</p><p className="text-[var(--modal-text-heading-clr)]  md:pt-5 pt-2 lg:text-[12px] md:text-[11px] sm:text-[10px] text-[11px] font-hanken-grotesk font-[400px] sm:font-medium md:leading-[20px] leading-[17px]">{t('You_authorize_your_wireless')}</p></div></>}
              {steps === 1 ? <p></p> : <><div className="flex items-start gap-2"><p className="text-[var(--modal-text-heading-clr)] lg:text-[13px] md:text-[11px] sm:text-[10px] text-[12px] font-hanken-grotesk font-semibold leading-[18px] sm:leading-[20px] pt-2 sm:pt-5">3.</p><p className="text-[var(--modal-text-heading-clr)]  md:pt-5 pt-2 lg:text-[12px] md:text-[11px] sm:text-[10px] text-[11px] font-hanken-grotesk font-[400px] sm:font-medium md:leading-[20px] leading-[17px]">{t("services_are_provided")}</p></div></>}
              {steps === 1? <p className="text-[var(--modal-text-heading-clr)] md:pt-5 pt-2 lg:text-[12px] md:text-[11px] sm:text-[10px] text-[13px] font-hanken-grotesk font-[400px] sm:font-medium  md:leading-[20px] leading-[17px]">
                {t("data_rates_may_apply")} Reply
                <span className="text-[#30BC89]"> {t("help")} </span>
                {t("help_number")}
                <span className="text-[#30BC89]"> {t("stop")} </span>
                {t("Message_frequency_varies")}
              </p> : <p></p>}
              {steps === 1 ? <p className="text-[var(--modal-text-heading-clr)]  md:pt-5 pt-2 lg:text-[13px] md:text-[11px] sm:text-[10px] text-[11px] font-hanken-grotesk font-[400px] sm:font-medium md:leading-[20px] leading-[17px]">{t('By_continuing_you')}<span className="text-[#2965FB] cursor-pointer underline" onClick={handleStepTwoClick}>{t('View_full_terms')}</span>.</p> : <p></p>}
              <div className={`sm:pt-5 mb-10 ${isFromSmiOne ? 'md:pt-12' : 'md:pt-6'} pt-8 flex flex-row justify-start `}>
              <input
                  id="agree"
                  tabIndex="0"
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      setphScreenAgreeTerms(!phScreenAgreeTerms);
                    }
                  }}
                  type="checkbox"
                  className="checkbox-custom-organic checkbox-no-shadow"
                  value=""
                  checked={phScreenAgreeTerms}
                  onChange={() => {
                    setphScreenAgreeTerms(!phScreenAgreeTerms);
                    setIsLoading(false);
                  }}
                />
                <label
                  htmlFor="agree"
                  className={`font-hanken-grotesk md:ml-6 ml-4 md:text-sm sm:text-[12px] text-[15px] font-[400] sm:font-medium text-[var(--transactions-filter-time-text)] dark:text-gray-300 `}
                >
                  {t("I_have_read")}
                </label>
              </div>
              {SingupCheckBoxMessage && (
                <div className="mt-4">
                  {displaySignupErrorMessage(SingupCheckBoxMessage, true)}
                </div>
              )}
                <div className={`absolute mb-10  ${isFromSmiOne ? 'sm:right-[-4rem]' : 'sm:right-[0rem]'} xsm:right-[0rem] right-[-1rem] `}>
                  <button
                    type="button"
                    className={continueButtonClasses}
                    disabled={isContinueDisabled}
                    onClick={handleMobileVerificationContinue}
                  >
                    {t('continue')}
                    <img
                      src={appThemeData.SignupNextArrow}
                      className={`${signUpkudzuPlusTrue ? '' : ''} 
             ml-2`}
                      alt=""
                    />
                  </button>
                </div>
              </>
            </div>
          }
        />
      )}

      {/* RESET SUCCESS MODAL */}
      <Modal
        isIframe={true}
        isOpen={showAgreementsModel}
        onClose={() => {
          setShowAgreementsModel(false);
          setIsMobileVerificationModalOpen(true);
        }}
        title={false}
        content={
          <div
            className="w-full h-full   md:pt-0 sm:pt-6  pt-16"
            style={{ height: window.innerHeight }}
          >
            <iframe
              src={policyURL}
              id="policyIframe"
              title="Embedded Website"
              className="w-full"
              style={{ height: window.innerHeight }}
            />
          </div>
        }
      />

      {/* {open Phone OTP verify modal} */}

      {isOTPVerifyModalOpen && (
        <Modal
          isOpen={isOTPVerifyModalOpen}
          onClose={debounce(closeOTPVerifyModal, 100)}
          title={<p className={HeadingStyles}> {t("")}</p>}
          isLogo={isFromSmiOne ? true : true} 
          defaultCornerRadius={isFromSmiOne ? false : true}
          subtitle={
            <>
              <p className={`${SubHeadingStyles} lg:w-[321px] sm:w-[204px]`}>
                <span className="text-[#2965FB]">First, </span>{t("let’s_verify")}
              </p>             
            </>
          }
          content={
            <div className="mt-10">
             <ValidatePhoneOTP
                        enableAuthorizedUserflow={debounce(handleAuthUserFlow, 100)}
                       existingErrorModalDisplay={(canContinue) =>
            debounce(() => handleExistingErrorModal(canContinue), 100)()
          }
              />
               <p className="text-[var(--modal-text-heading-clr)] md:pt-5 pt-2 lg:text-[12px] md:text-[11px] sm:text-[10px] text-[11px] font-hanken-grotesk font-[400px] sm:font-medium  md:leading-[20px] leading-[17px]">
                {t("data_rates_may_apply")} Reply
                <span className="text-[#30BC89]"> {t("help")} </span>
                {t("help_number")}
                <span className="text-[#30BC89]"> {t("stop")} </span>
                {t("Message_frequency_varies")}
              </p>
            </div>
          }
        />
      )}

      {authUserCodeModelOpen && (
        <Modal
          isOpen={authUserCodeModelOpen}
          onClose={debounce(closeAuthModal, 100)}
          isLogo={true}
          title={<p className={HeadingStyles}> {t("one_more_thing")}</p>}
          subtitle={
            <>
              <p className={SubHeadingStyles}>{t("provide_invite_code")}</p>
            </>
          }
          content={
            <div className="mt-10">
              <ValidateAuthCode
                handleAuthUserLogin={debounce(handleUserSuccess, 100)}
              />
            </div>
          }
        />
      )}
      {existingErrorModalOpen && (
       
        <Modal 
          isOpen={existingErrorModalOpen}
          onClose={debounce( idFromSmiOne ? closeSMIOneExistingErrModla :closeExistingErrModal, 100)}
          isLogo={false}
          title={<p className={HeadingStyles}> {isFromSmiOne ? t("Oops_smi") : t("oops_exclamation")} <span style={{color:"black"}}>{isFromSmiOne ?t("Linked_existing_mobile") : t("you_already_had_account") }</span></p>}
          subHeaderMsg={
            <>
              <p >{t("Please_log")}</p>
            </>
          }
          onContinueClick={true}
          content={
            isFromSmiOne ? (<>
             <ExistingErrorModal
               onLoginClick={() => {
                window.location.href = "/link-smione-card/Onboard"; } }
                onTryAgainClick={debounce(handleTryAgainExistingErr, 100)}
                onContinueClick={goToOnBoard}
                showContinue={canContinue}
            />
            </>):(<><ExistingErrorModal
              onLoginClick={debounce(() => navigate("/"), 100)}
              onTryAgainClick={debounce(handleTryAgainExistingErr, 100)}
            /></>)
            
          }
        />
      )}
      {/* Login verify device  MODAL */}

      <Modal
        isOpen={isLoginModalOpen}
        onClose={debounce(closeLoginModal, 100)}
        isLogo={false}
        title={
          <p className={`${HeadingStyles} hidden sm:flex`}>
            {t("great_exclamation")}
          </p>
        }
        subtitle={
          <p>
            <span className={`${HeadingStyles} visible sm:hidden`}>
              {t("great_exclamation")}
            </span>
            <span className={SubHeadingStyles}>
              {selectedOtpType === "Email"
                ? t("we_are_sending_email_message")
                : t("we_are_sending_you_text_with_verification_code")}
            </span>
          </p>
        }
        content={
          <div class="aspect-454/253 mt-5">
            <>
              {selectedOtpType !== "Email" && (
                <p
                  className="font-hanken-grotesk lg:text-[20px] md:text-[18px] sm:text-[14px]
             text-[16px] lg:leading-[30px] md:leading-[30px] sm:leading-[26px] leading-[24px]
              text-[var(--modal-text-heading-clr)] font-medium"
                >
                  {" "}
                  {t("standard_message")}{" "}
                </p>
              )}
              {/*  md:w-[392px] sm:w-[289px] w-full */}
            </>

            <VerifyOtp
              selectedOtpType={selectedOtpType}
              loginOtpErrorMessage={loginOtpErrorMessage}
              handleTryAgain={debounce(handleLoginOtpTryAgain, 100)}
              handleloginVerifyOtp={handleLoginVerifyDeviceClick}
              onCancelClick={debounce(closeLoginModal, 100)}
            />
            {/* <VerifyOtp selectedOtpType={selectedOtpType} loginOtpErrorMessage={loginOtpErrorMessage} handleTryAgain={debounce(handleLoginOtpTryAgain, 100)} handleloginVerifyOtp={debounce(handleLoginVerifyDeviceClick, 100)} onCancelClick={debounce(closeLoginModal, 100)} /> */}
          </div>
        }
      />

      {/* Login trust device  or not MODAL */}
      {isLoginTrustDeviceOpen && (
        <Modal
          isOpen={isLoginTrustDeviceOpen} //isLoginTrustDeviceOpen
          onClose={debounce(closeTrustDeviceLoginModal, 100)}
          isLogo={false}
          alignItems={"items-center"}
          title={<p className={HeadingStyles}>{t("success_heading")}</p>}
          subtitle={
            <p className={SubHeadingStyles}>{t("like_to_add_device")}</p>
          }
          content={
            <div class="aspect-454/253 mt-10">
              <div className="flex justify-center">
                <img
                  src={appThemeData.successIconTrust}
                  className="lg:w-[120px] md:w-[100px] sm:w-[92px] w-[100px] 
            lg:my-4 md:my-2 sm:my-4 my-6"
                  alt=""
                ></img>
              </div>
              <TrustDevice
                loginTrustDeviceClicked={debounce(loginTrustDeviceClicked, 100)}
             />
            </div>
          }
        />
      )}

      {/* VERIFY EMAIL MODAL */}
      <Modal
        isOpen={isVerifyEmailModalOpen}
        onClose={debounce(closeForgotPasswordInitialScreen, 100)}
        title={
          <p className={`${HeadingStyles} !text-[var(--heads-reset-clr)]`}>
            {t("reset_password_heading1")}
          </p>
        }
        subtitle={
          <div className="">
            <p
              className="font-hanken-grotesk modal-title mt-3
            lg:text-[20px] md:text-[18px] sm:text-[14px] text-[16px] sm:leading-[26px] lg:leading-[30px]
             md:leading-[30px] leading-[24px]
             font-[500] text-[var(--heads-reset-clr)] w-full"
            >
              {t("verify_email_parg1")}
              <span
                className="md:w-[420px] sm:w-[257px] font-hanken-grotesk modal-title mt-3 
          lg:text-[20px] md:text-[18px] sm:text-[14px] text-[16px] sm:leading-[26px] lg:leading-[30px] md:leading-[30px] leading-[24px]
            font-[500] text-[var(--heads-reset-clr)] my-5"
              >
                {t("verify_email_parg2_part1")}
                <span
                  tabIndex={0}
                  className="font-hanken-grotesk font-normal lg:text-[20px] md:text-[18px] sm:text-[14px] text-[16px] sm:leading-[20px] 
              lg:leading-[30px] md:leading-[30px] leading-[24px] text-[var(--signup-reset-clr)] underline cursor-pointer"
                  onKeyDown={(event) => {
                    if (event.key === "Enter") {
                      event.preventDefault();
                      handleSignUpClickInEmailModal();
                    }
                  }}
                  onClick={debounce(handleSignUpClickInEmailModal, 100)}
                >
                  {t("sign_up_lowercase")}
                </span>
                <span> {t("verify_email_parg2_part2")}</span>
              </span>
            </p>
          </div>
        }
        content={
          <div class="aspect-454/253 pl-[0px] pr-5 sm:px-0 mt-20">
            <VerifyEmail
              emailAdress={forgotEmailAddress}
              handleModalOnClick={debounce(
                handleModalOnImReadyButtonClick,
                100
              )}
            />
          </div>
        }
      />

      {/* SECURITY CHECK MODAL */}
      <Modal
        isOpen={isSecurityCheckModalOpen}
        onClose={debounce(closeSecurityCheckModal, 100)}
        title={
          <p
            className={`${HeadingStyles} !text-[var(--heads-reset-clr)] md:mb-5 sm:mb-2 mb-4`}
          >
            {t("reset_password_heading1")}
          </p>
        }
        subtitle={
          <p
            className="font-hanken-grotesk modal-title mt-3
        lg:text-[20px] md:text-[18px] sm:text-[14px] text-[16px] sm:leading-[26px] lg:leading-[30px] md:leading-[30px] leading-[24px]
         font-[500] text-[var(--heads-reset-clr)] w-full md:w-[395px] sm:w-[313px]"
          >
            {t("security_check_subheading1")}{" "}
            <p
              className="font-hanken-grotesk modal-title mt-3
         lg:text-[20px] md:text-[18px] sm:text-[14px] text-[16px] sm:leading-[26px] lg:leading-[30px] md:leading-[30px] leading-[24px]
          font-[500] text-[var(--heads-reset-clr)] w-full md:w-[395px] sm:w-[313px]"
            >
              {" "}
              {t("standrd_message_rates_apply")}
            </p>
          </p>
        }
        content={
          <div class="aspect-454/253 mt-10">
            <SecurityCheck
              handleModalOnClick={debounce(handleModalOnVerifyClick, 100)}
              handleSignUpClickInSecurityCheckModal={debounce(
                handleSignUpClickInSecurityCheckModal,
                100
              )}
            />
          </div>
        }
      />

      {/* RESET YOUR PASSWORD MODAL */}
      <Modal
        Fullheight={true}
        isOpen={isResetYourPassModalOpen}
        onClose={debounce(closeResetYourPassModal, 100)}
        title={
          <p
            className={`${HeadingStyles} !text-[var(--heads-reset-clr)] md:mb-5 sm:mb-2 mb-4`}
          >
            {t("reset_password_heading1")}
          </p>
        }
        subtitle={
          <p
            className="font-hanken-grotesk modal-title md:mt-3 sm:mt-0 mt-3
        lg:text-[20px] md:text-[18px] sm:text-[14px] text-[16px] sm:leading-[26px] lg:leading-[30px] md:leading-[30px] leading-[24px] font-[500] text-[var(--heads-reset-clr)] 
          sm:w-[450px]"
          >
            {t("reset_password_subheading1")}
          </p>
        }
        content={
          <div class="aspect-454/253 pl-[0px] pr-5 sm:px-0 mt-10">
            <ResetYourPassword
              handleModalOnClick={debounce(handleModalOnLoginClick, 100)}
            />
          </div>
        }
      />

      {/* RESET SUCCESS MODAL */}
      <Modal
        isOpen={isResetSuccessModalOpen}
        onClose={debounce(closeResetSuccessModal, 100)}
        title={
          <p className={HeadingStyles}>
            {t("success_pullstop")} <br />{" "}
            <span className=" text-[var(--heads-reset-clr)]">{t("success_msg")}</span>
          </p>
        }
        content={
          <div class="aspect-454/253 mt-10">
            <ResetSuccess openLoginModal={openLoginModalOpen} />
          </div>
        }
      />

      {/*2fa type selction modal*/}
      <TwoFactTypeSelctionModal
        highlightedText={kudzuPlusTrue ? t("Quick_security_check") : t("using_new_device_title")}
        headerText={ kudzuPlusTrue ? t('using_new_device_title') : t("you_ll_need_to_verify_this_action")}
        isOpen={show2faSelection}
        onClose={() => {
          setshow2faSelection(false);
        }}
        onClickNext={(object) => {
          setshow2faSelection(false);
          setSelectedOtpType(object.proc);
          callGenerateOtp(object.proc);
        }}
      />

      <CustomAlertModel isOpen={showModel} onClose={closeModel} image={modelImage}
        highlightMsg={<p className={`${HighlightMsgStyles} sm:flex block flex-col`}>{highlightMsg} <span className={`${HeaderMsgStyles} text-[var(--modal-text-heading-clr)]`}> {headerMsg}</span></p>}
        subHeaderMsg={<p className={SubHeaderMsgStyles}>{subHeaderMsg}</p>}
        btn1Exists={btn1Exists}
        btn2Exists={btn2Exists}
        btn1Text={btn1Text}
        btn2Text={btn2Text}
        btn1TypeAcpt={btn1TypeAcpt}
        onAcptBtnClick={onAcptBtnClick}
      />

      <CustomModalPlus isOpen={showPlusModal}
        onClose={debounce(closeModelPlus, 100)}
        image={modelImage}
        carousel={carousel}
        summaryParagraph={<p className={summaryParagraphStyles}>{summaryParagraph}</p>}
        isBorderNone={isBorderNone}
        highlightMsg={<p className={HeaderMsgStylesForPlus}> {headerMsg}</p>}
        subHeaderMsg={<p className={SubHeaderMsgStyles}>{subHeaderMsg}</p>}
        btn1Exists={btn1Exists}
        btn2Exists={btn2Exists}
        btn1Text={btn1Text}
        btn1BgColor={btn1BgColor}
        btn2Text={btn2Text}
        opacityLow={opacityValueLow}
        defaultCornerRadius={false}
        btn1TypeAcpt={btn1TypeAcpt}
        onAcptBtnClick={onAcptBtnClickPlusModal}
        onCancelBtnClick={debounce(onCancelBtnClickPlusModal, 100)}
        gradientButton={gradientButton}
        // largeImage={largeImage}
      />

        {
          kudzuSmiOneModal && (
            <Modal
            isOpen={kudzuSmiOneModal} //isLoginTrustDeviceOpen
            onClose={()=> setKudzuSmiOneModal(false)}
            defaultCornerRadius={false}
            isLogo={false}
            alignItems={"items-center"} 
            subtitle={ 
                <span className={SubHeadingStyles}>
                   <span className="text-[#2965FB]">{t('SMI_WELCOME')} </span><br></br>
                {addLineBreaks(t('SMI_WELCOME_CONTENT'))}
                </span> 
            }
            content={
              <>
              <div className="md:pt-10 lg:pb-3 md:pb-8 pt-4 pb-4 pr-[4rem]">
                <div className="flex flex-col gap-20 justify-center ">
   
                  <div className="flex flex-col justify-center items-center w-full">
                    <img
                      src={smiKudzu}
                      alt="Early access"
                      className="sm:ml-[4rem] ml-2"
                    />
                  </div>
   
                </div>
              </div>
              <div className=' flex flex-row justify-end md:relative md:left-[3.5rem]  sm:mx-0 mx-4 lg:mb-16 md:mb-16 mb-5'>
                    <button
                      type="button"  
                      className={`font-hanken-grotesk sm:font-bold font-[600]
                                  lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px]
                                   ${  'text-[var(--habit-add-clr)]'}
                                   cursor-pointer flex items-center`}
                      onClick={handleSmiOneContinue}
                      onKeyDown={(event) => {
                        if (event.key === "Enter") {
                          event.preventDefault();
                          // handleConfirm()
                        }
                      }}
                    >
                      {t('continue')} 
                      <img
                        src={  appThemeData.arrowWhiteTwofac  }
                        className="md:w-[14px] sm:w-[11px] md:h-[14px] sm:h-[11px] w-[14px] h-[14px] ml-1" 
                        alt="" />
                    </button>
                  </div> 
              </>
            }
          />
          )
        }
         {/* welcome carousel MODAL For SMI */}
      {isWelcomeCarouselModalOpenForSMI && (
        <Modal
          isOpen={isWelcomeCarouselModalOpenForSMI}
          onClose={(debounce(handleSmiOneContinue, 100))}
          defaultCornerRadius={false}
          isLogo={false}
          Fullheight={true}
          bgColor={'bg-[#FEFAEE]'}
          content={
            <div>
              <LandingCarousel 
                onSkipClick={(debounce(handleSmiOneContinue, 100))}
                onKudzuPlusClick={(debounce(handleSmiOneContinue, 100))} 
              />
            </div>
          }
        />
      )}

        {
          showSmiOneErrorModal && (
            <Modal
            isOpen={showSmiOneErrorModal} //isLoginTrustDeviceOpen
            onClose={()=> {navigate('/'); setShowSmiOneErrorModal(false); dispatch({ type: 'FROM_SMI_ONE', payload: { fromSmiOne: false} })}}
            defaultCornerRadius={false}
            isLogo={false}
            alignItems={"items-center"} 
            title={<span className={`${HeadingStyles}`}>
            {t("oops_exclamation")}{" "}
          </span>}
            subtitle={ 
                <span className={SubHeadingStyles}>
                  {responseErrorMsg}
                </span> 
            }
            content={
              <>
              <div className="md:pt-5 lg:pb-3 md:pb-8 pt-4 pb-4">
                <div className="flex flex-col gap-20 justify-center ">
   
                  <div className="flex flex-col justify-center items-center w-full">
                    <img
                      src={appThemeData.coveredByKudzuIneligibleineligibleIcon}
                      alt="Early access"
                      className=" md:w-[150px] sm:w-[92px]  md:my-10 sm:my-10 my-8"
                    />
                  </div>
   
                </div>
              </div>
              <div className=' flex flex-col justify-center items-center gap-8 w-full'>
                    

                    <button autoFocus class="focus:outline-none   font-hanken-grotesk lg:text-[18px] md:text-[17px] 
                sm:text-[15px] text-[16px] font-[500] sm:font-bold leading-[24px] sm:leading-[12px] md:leading-[16px] bg-[#2965FB] text-white cursor-pointer border-2 px-2 py-4 border-[#2965FB] w-full" onClick={ ()=> {navigate('/'); setShowSmiOneErrorModal(false); dispatch({ type: 'FROM_SMI_ONE', payload: { fromSmiOne: false} })}} >{t("Ok")}</button>
                
                 
                </div>
              
 
              </>
            }
          />
          )
        }

      {isLoading && <Loader />}

      {showCarouselScreenShow &&
        <MemnershipEnrollmentScreens isSignUpAccept={debounce(handleSignUpAccept, 100)} isSignUpCancel={debounce(handleisSignUpCancel)} />
      }
    </>
  );
};

export default PreLogin;